/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Search_Anything_HintInputs */

const en_events_search_anything_hint = /** @type {(inputs: Events_Search_Anything_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titles, descriptions, businesses and hosts`)
};

const pl_events_search_anything_hint = /** @type {(inputs: Events_Search_Anything_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytuły, opisy, firmy i prowadzący`)
};

/**
* | output |
* | --- |
* | "Titles, descriptions, businesses and hosts" |
*
* @param {Events_Search_Anything_HintInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const events_search_anything_hint = /** @type {((inputs?: Events_Search_Anything_HintInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Search_Anything_HintInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_events_search_anything_hint(inputs)
	return en_events_search_anything_hint(inputs)
});